import React from 'react'
import { GreyBackgroundButton, GreyBorderButton } from '../Global/GlobalButton';
import { useNavigate } from 'react-router-dom';

const Page404 = () =>{
    const navigate = useNavigate()
    return(
        < div style={{display:"flex",flexDirection:"column", marginTop:"3rem" , justifyContent:"center", alignItems:"center"}}>
        404
        <GreyBorderButton style={{display:"flex", marginTop:"3rem" , justifyContent:"center", alignItems:"center"}}
         onClick={()=>navigate("/")}
        >
         Go TO Home Page
        </GreyBorderButton>
        </ div>
    )
}
export default Page404;